import { useEffect, useRef } from 'react'

import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { SET_PERMISSIONS, SET_PERMISSIONS_ERROR } from '@percent/admin-dashboard/context/auth/authReducer/authReducer'
import { logger } from '@percent/admin-dashboard/common/utility/logger'
import {
  AuthStateContextType,
  AuthDispatchContextType
} from '@percent/admin-dashboard/context/auth/authContext/AuthContext.types'
import { fetchPermissions } from './fetchPermissions'

export const useFetchPermissions = (state: AuthStateContextType, dispatch: AuthDispatchContextType) => {
  const { iamService } = useServices()
  const isFetchingRef = useRef(false)

  useEffect(() => {
    if (!state.shouldRefetchPermissions || isFetchingRef.current) return

    const refetch = async () => {
      isFetchingRef.current = true

      try {
        const permissions = await fetchPermissions(iamService)

        dispatch({
          type: SET_PERMISSIONS,
          permissions
        })
      } catch (error) {
        logger(error as Error)

        dispatch({
          type: SET_PERMISSIONS_ERROR
        })
      } finally {
        isFetchingRef.current = false
      }
    }

    refetch()
  }, [state.shouldRefetchPermissions, iamService, dispatch])
}
